import React, { Component } from 'react'
import PlayersCountButton from 'frontend/schedule/players-count-button'
import PropTypes from 'prop-types'

export default class PlayersCountButtons extends Component {
  static propTypes = {
    playersWithMinPrices: PropTypes.array.isRequired,
    minPlayers: PropTypes.number,
    maxPlayers: PropTypes.number,
    selected: PropTypes.number,
    disabled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = { selected: props.selected }
  }

  onSelect (count) {
    if (this.props.disabled) return

    this.props.onSelect(count)
  }

  // Flat price rooms have no per players count prices, so there is nothing to
  // build the buttons from - fall back to the plain range, priceless. The input
  // that carries the count on mobile is hidden from medium up.
  options () {
    const { playersWithMinPrices: priced, minPlayers, maxPlayers } = this.props
    return priced.length || !minPlayers || !maxPlayers
      ? priced
      : Array.from({ length: maxPlayers - minPlayers + 1 }, (_, index) => ({ count: minPlayers + index }))
  }

  renderButtons () {
    return this.options().map((option, index) => {
      return (
        <PlayersCountButton
          key={index}
          onSelect={this.onSelect.bind(this)}
          label={option.label}
          count={option.count}
          selected={this.props.selected}
          price={option.price}
        />
      )
    })
  }

  render () {
    return (
      <div className={['players_count_buttons', this.props.disabled ? 'disabled' : ''].join(' ')}>
        {this.renderButtons()}
      </div>
    )
  }
}
